




































import { defineComponent, PropType } from "@vue/composition-api";
import OccModal from "@/components/Atoms/OccModal/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";

export default defineComponent({
  components: {
    OccModal,
    OccButton,
    OccHeading
  },
  emits: ["close", "confirm"],
  props: {
    title: {
      type: String,
      default: undefined
    },
    titleLevel: {
      type: Number as PropType<1 | 2>,
      default: 1,
      validator: (level: number) => {
        return [1, 2].includes(level);
      }
    },
    description: {
      type: String,
      default: undefined
    },
    cancelText: {
      type: String,
      default: "キャンセル"
    },
    confirmText: {
      type: String,
      default: "OK"
    },
    hideCancel: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  name: "ConfirmModal"
});
